import $ from 'jquery';
import axios from 'axios';
import 'slick-carousel';
import { getDOMVehicleCard } from './featured-utilities.js';
import '../components/payment-calc/dsp-calculator.js';

function initSlider($slider, initial = 4, type, $currentSlide, $group) {
  $slider.on('init beforeChange', function (event, slick) {
    if (slick.$dots) {
      const dots = slick.$dots.find('li');
      const theme = $group.find(`.controls-dots-featured-slider-${type}`).data('theme');
      dots.addClass('slick-dot ' + theme);
    }
  });

  $slider.slick({
    slidesToShow: initial,
    slidesToScroll: 1,
    autoplay: false,
    dots: true,
    arrows: true,
    infinite: true,
    appendDots: $(`.controls-dots-featured-slider-${type}`),
    nextArrow: $(`.controls-next-featured-slider-${type}`),
    prevArrow: $(`.controls-prev-featured-slider-${type}`),
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '8%',
        },
      },
    ],
  });

  // sets position
  $slider.on('init beforeChange afterChange', function (event, slick) {
    $slider.slick('setPosition');
  });

  // Adjusts height of all slides to the tallest one
  $slider.on('setPosition', function (e, slick) {
    slick.$slides.css('height', slick.$slideTrack.height() + 'px');
  });

  $slider.on('init reInit afterChange', function (event, slick, currentSlide) {
    const current = (currentSlide ? currentSlide : 0) + 1;
    if ($currentSlide) {
      $currentSlide.text(current + '/' + slick.slideCount);
    }
  });
}

function initializeFeaturedGroup($group) {
  const $currentSlide = $group.find('.controls_current');
  const url = new URL(window.location.origin + '/inventory/search');
  const type = $group.data('type');
  const curb = parseInt($group.data('curb'));
  const hasSlider = $group.data('has-slider');
  let fillerCardConfig = $group.data('filler-card');
  const cardFeatures = $group.data('selected-features');

  if (type == 'featured') {
    url.searchParams.append('is_featured', true);
  }

  axios.get(url).then( async (res) => {
    let data = res.data.items;

    if (type == 'new') {
      data = data.filter((vehicle) => vehicle.is_new == true);
    }

    if (type == 'used') {
      data = data.filter((vehicle) => vehicle.is_new == false);
    }

    if (fillerCardConfig) {
      const inventoryCount = data.length;
      fillerCardConfig.inventoryCount = inventoryCount;
    }

    data = data.slice(0, curb ? curb : 8);

    if (data.length > 0) {
      const $featuredSlider = $group.find('.featured-slider');
      const disclaimer = $featuredSlider.data('disclaimer');
      const initial = $featuredSlider.data('initial');

      const $$allCards = [];

      // must be syncronized to maintain order from OEM API
      for (const model of data) {
        let $card = await getDOMVehicleCard(model, $group, disclaimer, cardFeatures);
        $$allCards.push($card);

      }

    

      $$allCards.forEach(($card) =>{
        $featuredSlider.append($card);
      });

      if (fillerCardConfig) {
        $featuredSlider.append(getDOMFillerCard(fillerCardConfig));
      }

      if (hasSlider == true) {
        initSlider($featuredSlider, initial, type, $currentSlide, $group);
      }

      if ($currentSlide) {
        $currentSlide.text('1/' + data.length);
      }

      $group.find('.featured-scene').hide();
      $featuredSlider.addClass('opacity-100');
      $featuredSlider.removeClass('opacity-0');

      setTimeout(function () {
        // $featuredSlider.find('.featured-card').removeClass('opacity-0');
        // $featuredSlider.find('.featured-image').removeClass('opacity-0');
      }, 1000);
    } else {
      $group.find('.featured-scene').hide();
    }
  });
}


if ($('.dsp-featured').length) {

  let myFunction = function (entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        initializeFeaturedGroup($(entry.target));
        observer.unobserve(entry.target);
      }
    });
  };

  let options = {
    root: null,
    rootMargin: '0px',
    threshold: 1.0,
  };

  const myObserver = new IntersectionObserver(myFunction, options);

  $('.dsp-featured').each(function () {
    myObserver.observe(this);
  });

}


